import { render, staticRenderFns } from "./SelectTraverList.vue?vue&type=template&id=006bc3cc"
import script from "./SelectTraverList.vue?vue&type=script&lang=js"
export * from "./SelectTraverList.vue?vue&type=script&lang=js"
import style0 from "./SelectTraverList.vue?vue&type=style&index=0&id=006bc3cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports